import React from 'react';
import './AnimatedBackground.css';

const AnimatedBackground = () => {
  return (
    <div className="animated-background">
      <div className="aliens-container">
        {[...Array(6)].map((_, i) => (
          <div key={i} className={`alien alien-${i + 1}`}>
            <div className="alien-body">
              <div className="alien-head">
                <div className="alien-eye left-eye"></div>
                <div className="alien-eye right-eye"></div>
              </div>
              <div className="alien-antenna"></div>
            </div>
          </div>
        ))}
      </div>
      <div className="stars"></div>
    </div>
  );
};

export default AnimatedBackground;











